import React, { lazy, Suspense } from 'react';
import { extendIcons } from './components/Graphic';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';


// lazy imports
const Home2 = lazy(() => import('./pages/HomePage/HomePage'));
const Admin2 = lazy(() => import('./pages/AdminPage/AdminPage'));
const GuestAppt2 = lazy(() => import('./demos/GuestAppt/GuestAppt'));
const GuestRefill2 = lazy(() => import('./demos/GuestRefill/GuestRefill'));
const MobileDemo2 = lazy(() => import('./demos/MobileDemo/MobileDemo'));
const GuestPay2 = lazy(() => import('./demos/GuestPay/GuestPay'));
const PatientPay2 = lazy(() => import('./demos/PatientPay/PatientPay'));
const PayDemo2 = lazy(() => import('./demos/PayDemo/PayDemo'));
const Playground2 = lazy(() => import('./demos/Playground/Playground'));
const ReportsDemo2 = lazy(() => import('./demos/ReportsDemo/ReportsDemo'));
const VucaCountry2 = lazy(() => import('./demos/VucaCountry/VucaCountry'));



function App() {

  React.useEffect(() => {
    // set id on html tag
    var htmlTag = document.getElementsByTagName("html")[0];
    const demoId = window.location.pathname.split('/')[1]?.split('-')[1];
    if(demoId) htmlTag.setAttribute('id', 'demo-' + demoId);


    // extend icons
    extendIcons({
      'download': ["M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"],
    });


  }, []);
  
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home2 />} />
          <Route path="*" element={<Home2 errorType="404" />} />
          <Route exact path="/1234-admin" element={<Admin2 />} />


          <Route exact path="/9084-guestappt" element={<GuestAppt2 version={1} />} />
          <Route exact path="/9084-guestappt/2" element={<GuestAppt2 version={2} />} />

          <Route exact path="/8327-guestrefill" element={<GuestRefill2 version={1} />} />
          <Route exact path="/8327-guestrefill/2" element={<GuestRefill2 version={2} />} />
          <Route exact path="/8327-guestrefill/3" element={<GuestRefill2 version={3} />} />
          
          <Route exact path="/7382-mobileweb" element={<MobileDemo2 version={1} />} />
          
          <Route exact path="/2618-guestpay" element={<GuestPay2 version={1} />} />
          <Route exact path="/8274-patientpay" element={<PatientPay2 version={1} />} />
          {/* <Route exact path="/vucacountry" element={<VucaCountry2 />} /> */}
          <Route exact path="/3648-vucacountry" element={<VucaCountry2 />} />


          {/* --- new demos --- */}

          <Route exact path="/playground" element={<Playground2 />} />
          <Route exact path="/9128-reportsdemo" element={<ReportsDemo2 />} />
          <Route exact path="/5294-paydemo" element={<PayDemo2 version={1} />} />
          
        </Routes>
      </Suspense>
    </Router>
  );
}

/*
Patient sync
Payments chat feature
IVR Queue Reports
---
WPA patterns and testing
Payments chat work
URAC Report



WPA guidelines
Onboarding tracker tools changes
Lum visualization updates
--- 
LUM Pulse feedback
Meds order
Payments updates

*/

/*
Make an interactive prototype of a report for a pharmacy's automated phone system:
The pharmacy uses an automated phone system (IVR) that will try to get what the caller needs so a person does have to answer the call. Here are the 4 menu options in the phone system: Refill,  Order status, prescriber office, and business hours. 
A vast majority of callers call about refills. The second most popular option is order status.
A transferred call means a person has to answer the call which is not good. Show that people calling about an order status has a much high transfer rate than the other options.
The design is an example of 1 day.
The pharmacy has 5 pharmacists working there. 
Use mock data.
Make it so you can see different time periods using the navigation to the right of the title: 1D = 1 day, 7D = 7 days, 1M = 1 month, 3M = 3 months, 1Y = 1 year.
Fill in the table at the bottom with the mock data. 
The peak times are in the morning and late afternoon. 
The pharmacy store hours are 8 am - 9 pm 7 days a week. 
It is less busy on the weekends.
Don't worry about the page wrapper, I will add that later.
Order status Order status 
*/

export default App;
